/* ────────────────────────────── */
/*  TESTIMONIALS DATA */
/* ────────────────────────────── */

const avatars = [
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle-aged%20Taiwanese%20businessman%20in%20his%2050s%20wearing%20a%20light%20blue%20casual%20shirt%2C%20warm%20natural%20lighting%2C%20clean%20neutral%20cream%20background%2C%20friendly%20confident%20expression%2C%20editorial%20quality%20portrait%20photography%2C%20warm%20tones%2C%20no%20text%20no%20logos&width=200&height=200&seq=testimonial-1&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Taiwanese%20woman%20in%20her%2040s%20with%20short%20elegant%20hair%20wearing%20a%20white%20blouse%2C%20warm%20natural%20lighting%2C%20clean%20neutral%20cream%20background%2C%20gentle%20warm%20smile%2C%20editorial%20quality%20portrait%20photography%2C%20soft%20warm%20tones%2C%20no%20text%20no%20logos&width=200&height=200&seq=testimonial-2&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Taiwanese%20man%20in%20his%20late%2030s%20wearing%20a%20dark%20gray%20polo%20shirt%2C%20warm%20natural%20lighting%2C%20clean%20neutral%20cream%20background%2C%20relaxed%20friendly%20expression%2C%20editorial%20quality%20portrait%20photography%2C%20warm%20earth%20tones%2C%20no%20text%20no%20logos&width=200&height=200&seq=testimonial-3&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20mature%20Taiwanese%20woman%20in%20her%2060s%20with%20silver-gray%20hair%20wearing%20a%20beige%20cardigan%2C%20warm%20natural%20lighting%2C%20clean%20neutral%20cream%20background%2C%20kind%20wise%20expression%2C%20editorial%20quality%20portrait%20photography%2C%20soft%20warm%20tones%2C%20no%20text%20no%20logos&width=200&height=200&seq=testimonial-4&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Taiwanese%20man%20in%20his%2050s%20wearing%20a%20green%20checkered%20shirt%2C%20warm%20natural%20lighting%2C%20clean%20neutral%20cream%20background%2C%20cheerful%20outdoorsy%20expression%2C%20editorial%20quality%20portrait%20photography%2C%20warm%20golden%20tones%2C%20no%20text%20no%20logos&width=200&height=200&seq=testimonial-5&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Taiwanese%20woman%20in%20her%20early%2030s%20with%20glasses%20wearing%20a%20light%20gray%20sweater%2C%20warm%20natural%20lighting%2C%20clean%20neutral%20cream%20background%2C%20bright%20professional%20smile%2C%20editorial%20quality%20portrait%20photography%2C%20soft%20warm%20tones%2C%20no%20text%20no%20logos&width=200&height=200&seq=testimonial-6&orientation=squarish",
];

const testimonials = [
  {
    name: "李先生",
    role: "台北・自地自建業主",
    avatar: avatars[0],
    rating: 5,
    text: "從一開始的土地評估到最後交屋，整個過程都透明且專業。預製工法真的縮短了不少時間，比我預期快了兩個多月。",
  },
  {
    name: "張小姐",
    role: "台中・多代同堂家族",
    avatar: avatars[1],
    rating: 5,
    text: "三代同堂的動線規劃非常細心，長輩房的設計讓爸媽住得很舒適。室內外的整合感很強，家人都很滿意。",
  },
  {
    name: "陳先生",
    role: "台南・危老重建業主",
    avatar: avatars[2],
    rating: 5,
    text: "老屋重建原本以為會很麻煩，但整個團隊從報建到施工都幫我處理得很妥當。現在的新家採光和通風都非常好。",
  },
  {
    name: "王女士",
    role: "新竹・退休規劃業主",
    avatar: avatars[3],
    rating: 5,
    text: "退休宅的無障礙設計和低維護材料選擇很貼心，夏天室內確實涼爽很多。設計師真的把我們的生活需求聽進去了。",
  },
  {
    name: "林先生",
    role: "屏東・農地自建業主",
    avatar: avatars[4],
    rating: 5,
    text: "農地上的房子完工後，景觀視野和露台設計完全超出預期。每天早上起床看到田園風景，心情都變好了。",
  },
  {
    name: "黃小姐",
    role: "新竹・預製工法業主",
    avatar: avatars[5],
    rating: 5,
    text: "預製工法的品質穩定度讓人很放心，現場也乾淨很多。工程進度幾乎和預定計畫完全一致，很少延期。",
  },
];

/* ────────────────────────────── */
/*  COMPONENT */
/* ────────────────────────────── */

export default function TestimonialsSection() {
  return (
    <section className="bg-cream section-padding">
      <div className="container-main px-4 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="tag-label mb-4 inline-block">CLIENT STORIES</span>
          <h2 className="text-graphite mb-4">客戶評價 / 見證</h2>
          <p className="text-medium-gray max-w-2xl mx-auto">
            每一位業主的故事，都是從一塊土地、一個家庭夢想開始。聽聽他們怎麼說。
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-6 md:p-8 border border-warm-gray/30 transition-all duration-300 hover:-translate-y-1 hover:border-champagne/30 hover:shadow-md group"
            >
              {/* Avatar + Name */}
              <div className="flex items-center gap-4 mb-5">
                <div className="w-14 h-14 rounded-full overflow-hidden shrink-0 border-2 border-champagne/20 group-hover:border-champagne/40 transition-colors duration-300">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="text-graphite text-[1.0625rem] font-semibold leading-tight">
                    {item.name}
                  </h3>
                  <p className="text-medium-gray text-sm mt-0.5">{item.role}</p>
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: item.rating }).map((_, s) => (
                  <span
                    key={s}
                    className="w-5 h-5 flex items-center justify-center text-champagne"
                  >
                    <i className="ri-star-fill text-base" />
                  </span>
                ))}
              </div>

              {/* Quote */}
              <p className="text-medium-gray text-base leading-relaxed">
                &ldquo;{item.text}&rdquo;
              </p>
            </div>
          ))}
        </div>

        {/* Bottom CTA hint */}
        <div className="text-center mt-10 md:mt-14">
          <p className="text-medium-gray text-base">
            想成為下一個滿意的業主？
          </p>
        </div>
      </div>
    </section>
  );
}